export const LocalStorageDataModel = {
  AUTH_KEY: 'token',
  USER_DATA: 'user',
  CART_ITEMS: '_cartItems',
  CART_COUNT: '_cartCount',
};
